import axios from "axios";
import { handleUnauthorized } from "./session401";

const AxiosV2 = axios.create({
  baseURL: `${process.env.REACT_APP_API_V2_CONNECTION}`,
  timeout: 60000,
  headers: {
    "Content-Type": "application/json"
  },
});

AxiosV2.defaults.headers.common["content-type"] = "application/json";
AxiosV2.defaults.headers.common["application"] = "web";
AxiosV2.defaults.headers.common["x-app"] = "web";

// Interceptor para agregar el token en cada request
AxiosV2.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Interceptor de respuesta mejorado
AxiosV2.interceptors.response.use(
  (response) => response,
  (error) => {
    // 401: solo expulsa si el token está vencido de verdad y el refresh falla;
    // un 401 puntual con token vigente se propaga a la vista. Ver session401.js.
    if (error.response && error.response.status === 401) {
      return handleUnauthorized(error, AxiosV2);
    }
    
    return Promise.reject(error);
  }
);

export default AxiosV2;